import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {LabeledModelService} from '../../../Models/YuChef/Labeled/labeled-model.service';
import {LabeledFilters} from '../../../../Models/YuChef/Labeled/labeled-filters.model';
import {LabeledStoreForm} from '../../../../Models/YuChef/Labeled/labeled-store.model';
import {DoLabelParams, LabelHistoryParams} from '../../../../Models/YuChef/Labeled/labeled.interface';

@Injectable({
  providedIn: 'root'
})
export class LabeledApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: LabeledModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener el listado de etiquetas
   *
   */
  public getLabeled(params: LabeledFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEtiquetado', params).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar una etiqueta
   *
   */
  public setLabel(form: LabeledStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setEtiquetadoProducto', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Marcar favorita la etiqueta
   *
   */
  public setFavoriteLabel(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setEtiquetadoFavorito', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Etiquetar
   *
   */
  public doLabel(params: DoLabelParams): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setEtiquetado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener el historial de las etiquetas
   *
   */
  public getLabelHistory(params: LabelHistoryParams): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProductoUltimasEtiquetas', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar etiqueta
   *
   */
  public deleteLabel(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteEtiquetado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
